import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";

/** Commission edit (brief §5). Saving also writes net charter fee to HubSpot;
 *  the toast says so, and says when HubSpot refused. */
export type CommissionBody = { mode: "pct" | "amount"; commissionPct?: number | null; commissionAmount?: number | null };

export const useBookingCommissionMutation = (bookingId: string) => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (body: CommissionBody) =>
      fetch<{ data: { netCharterFee: number; currency: string | null; hubspot: { written: boolean; error?: string } } }>(
        `/api/bookings/${bookingId}/commission`,
        "PATCH",
        body,
      ),
    onSuccess: (res: any) => {
      const hs = res?.data?.hubspot;
      toast({
        title: "Commission saved",
        description: hs?.written
          ? "Net charter fee written to HubSpot."
          : `Saved here, but HubSpot wasn't updated${hs?.error ? `: ${hs.error}` : "."}`,
        variant: hs?.written ? "default" : "destructive",
      });
      queryClient.invalidateQueries({ queryKey: ["bookingYachtOfferData", bookingId] });
    },
    onError: (error: any) => {
      toast({ title: "Error", description: error.message || "Failed to save commission.", variant: "destructive" });
    },
  });
};
